import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";

import {
  calcEst,
  showEst,
  optionsRequired,
  FONT_FAMILY,
} from "../common/sharedFunctions";
import { api } from "common";

// Import Material Icons for non-customer roles
import DashboardIcon from "@mui/icons-material/Dashboard";
import OfferIcon from "@mui/icons-material/LocalOffer";
import NotifyIcon from "@mui/icons-material/NotificationsActive";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import EmojiPeopleIcon from "@mui/icons-material/EmojiPeople";
import AssessmentIcon from "@mui/icons-material/Assessment";
import MoneyIcon from "@mui/icons-material/Money";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import SosIcon from "@mui/icons-material/Sos";
import AnnouncementOutlinedIcon from "@mui/icons-material/AnnouncementOutlined";

// Import SVG icons for new dashboards
import { ReactComponent as SendIcon } from "../assets/img/send.svg";
import { ReactComponent as ClockIcon } from "../assets/img/clock.svg";
import { ReactComponent as WalletIcon } from "../assets/img/Wallet.svg";
import { ReactComponent as ProfileIcon } from "../assets/img/profile.svg";
import { ReactComponent as SettingsIcon } from "../assets/img/settings.svg";
import { ReactComponent as LogOutIcon } from "../assets/img/logout.svg";
import { ReactComponent as CarIcon } from "../assets/img/navigation-car-icon.svg";

import DriverLogo from "../assets/img/haraka_logo.jpeg";
import RiderLogo from "../assets/img/haraka_logo.jpeg";
import AdminLogo from "../assets/img/haraka_logo.jpeg";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Box, Divider, Stack, Typography } from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";

const paddingX = "24px";
const applyStyles = (role) => ({
  "& .menuItem": {
    margin: "8px 0",
    padding: "12px 16px",
    borderRadius: "8px",
    transition: "all 0.3s ease-in-out",

    "&:hover": {
      backgroundColor:
        role === "customer"
          ? "#B3DBA8"
          : role === "driver"
          ? "#B3DBA8"
          : "#f277dc",
      "& p": { color: "#202224 !important" },
      "& svg path": {
        stroke: "#202224",
        // fill: "#FFFFFF",
      },
    },
    "a:hover": {
      backgroundColor: "transparent",
    },
  },
  "& .activeMenuItem": {
    backgroundColor:
      role === "customer"
        ? "#5BAA59"
        : role === "driver"
        ? "#4F913C"
        : "#DA4CBF",
    transition: "all 0.3s ease-in-out",

    "& p": {
      color: "#FFFFFF !important",
    },

    "& svg path": {
      stroke: "#FFFFFF",
      // fill: "#FFFFFF",
    },

    "&::before": {
      content: "''",
      position: "absolute",
      top: "0",
      left: `calc(-1 * ${paddingX})`,
      width: "4px",
      height: "100%",
      borderRadius: "0 6px 6px 0",
      backgroundColor:
        role === "customer"
          ? "#5BAA59"
          : role === "driver"
          ? "#4F913C"
          : "#DA4CBF",
      zIndex: "1",
    },
  },
  "& .MuiListItemText-root": {
    marginBlock: 0,
  },
});

const MenuItems = ({ role, handleDrawer }) => {
  const { signOff } = api;
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const isRTL = i18n.dir();

  const LogOut = () => {
    dispatch(signOff());
    navigate("/login");
  };

  return (
    <Stack
      sx={{
        position: "relative",
        backgroundColor: role === "" ? "#1E1E1E" : "#ffffff",
        height: "100%",
        direction: isRTL === "rtl" ? "rtl" : "ltr",
        paddingInline: "24px",
        ...applyStyles(role),
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "start",
        }}
      >
        <img
          style={{
            marginTop: "40px",
            marginBottom: role === "driver" ? "10px" : "5px",
            marginLeft: "20px",
            width: "150px",
          }}
          src={
            role === "customer"
              ? RiderLogo
              : role === "driver"
              ? DriverLogo
              : AdminLogo
          }
          alt="Logo"
        />
      </div>

      <Stack justifyContent="space-between" flexGrow={1}>
        {/* top navigation */}
        <Box>
          {role ? (
            <List disablePadding={true} dense={false}>
              {[
                {
                  name: t("dashboard_text"),
                  url: "/dashboard",
                  icon: <DashboardIcon />,
                  access: [],
                },
                {
                  name: t("add_booking_title"),
                  url: "/addbookings",
                  icon: <SendIcon />,
                  access:
                    calcEst && !showEst && !optionsRequired
                      ? ["customer"]
                      : ["customer"],
                },
                {
                  name: t("booking_history"),
                  url: "/bookings",
                  icon: <ClockIcon />,
                  access: ["driver", "customer"],
                },
                {
                  name: t("user"),
                  url: "/users/0",
                  icon: <EmojiPeopleIcon />,
                  access: [],
                },

                {
                  name: t("car_type"),
                  url: "/cartypes",
                  icon: <CarIcon />,
                  access: [""],
                },
                {
                  name: t("cars"),
                  url: "/cars",
                  icon: <CarIcon />,
                  access: ["driver"],
                },

                {
                  name: t("withdraws_web"),
                  url: "/withdraws",
                  icon: <MoneyIcon />,
                  access: [""],
                },
                {
                  name: t("add_to_wallet"),
                  url: "/addtowallet",
                  icon: <AccountBalanceWalletIcon />,
                  access: [""],
                },

                {
                  name: t("report"),
                  url: "/allreports",
                  icon: <AssessmentIcon />,
                  access: [],
                },
                {
                  name: t("promo"),
                  url: "/promos",
                  icon: <OfferIcon />,
                  access: [""],
                },
                {
                  name: t("push_notifications"),
                  url: "/notifications",
                  icon: <NotifyIcon />,
                  access: [""],
                },
                {
                  name: t("sos"),
                  url: "/sos",
                  icon: <SosIcon />,
                  access: [""],
                },
                {
                  name: t("complain"),
                  url: "/complain",
                  icon: <AnnouncementOutlinedIcon />,
                  access: [""],
                },
                {
                  name: t("my_wallet_tile"),
                  url: "/userwallet",
                  icon: <WalletIcon />,
                  access: ["driver", "customer"],
                },
                {
                  name: t("settings_title"),
                  url: "/settings",
                  icon: <PhoneIphoneIcon />,
                  access: [""],
                },
                {
                  name: t("profile"),
                  url: "/profile",
                  icon: <ProfileIcon />,
                  access: ["driver", "customer"],
                },
              ].map((item, index) =>
                item.access.includes(role) ? (
                  <ListItem
                    key={item.name + index}
                    disableGutters={true}
                    disablePadding={true}
                    alignItems="center"
                    dense={false}
                    onClick={handleDrawer}
                    className={`menuItem ${
                      `/${location.pathname.split("/")[1]}` === item.url
                        ? "activeMenuItem"
                        : ""
                    }`}
                  >
                    <ListItemButton
                      disableGutters={true}
                      disableRipple
                      dense={false}
                      component={Link}
                      to={item.url === "logout" ? null : item.url}
                      onClick={item.url === "logout" ? LogOut : null}
                    >
                      <ListItemIcon>{item.icon}</ListItemIcon>
                      <ListItemText
                        inset={false}
                        disableTypography={false}
                        primary={
                          <Typography
                            style={{
                              textAlign: isRTL === "rtl" ? "right" : "left",
                              fontFamily: FONT_FAMILY,
                              margin: 0,
                            }}
                          >
                            {item.name}
                          </Typography>
                        }
                      />
                    </ListItemButton>
                    <Divider />
                  </ListItem>
                ) : null
              )}
            </List>
          ) : null}
        </Box>

        <Stack>
          <Divider />

          {/* bottom navigation */}
          <Box sx={{ marginTop: "auto" }}>
            {role ? (
              <List disablePadding={true} dense={false}>
                {[
                  {
                    name: t("payment_settings"),
                    url: "/paymentsettings",
                    icon: <ClockIcon />,
                    access: [""],
                  },
                  {
                    name: t("settings_title"),
                    url: "/settings",
                    icon: <SettingsIcon />,
                    access: [""],
                  },
                  {
                    name: t("profile"),
                    url: "/profile",
                    icon: <ProfileIcon />,
                    access: [""],
                  },
                  {
                    name: t("logout"),
                    url: "logout",
                    icon: <LogOutIcon />,
                    access: ["driver", "customer"],
                  },
                ].map((item, index) =>
                  item.access.includes(role) ? (
                    <ListItem
                      key={item.name + index}
                      disableGutters={true}
                      disablePadding={true}
                      alignItems="center"
                      dense={false}
                      onClick={handleDrawer}
                      className={`menuItem ${
                        location.pathname.split("/")[0] === item.url
                          ? "activeMenuItem"
                          : ""
                      }`}
                    >
                      <ListItemButton
                        disableGutters={true}
                        disableRipple
                        dense={false}
                        component={Link}
                        to={item.url === "logout" ? null : item.url}
                        onClick={item.url === "logout" ? LogOut : null}
                      >
                        <ListItemIcon>{item.icon}</ListItemIcon>
                        <ListItemText
                          margin={0}
                          inset={false}
                          disableTypography={false}
                          primary={
                            <Typography
                              style={{
                                textAlign: isRTL === "rtl" ? "right" : "left",
                                fontFamily: FONT_FAMILY,
                                margin: 0,
                              }}
                            >
                              {item.name}
                            </Typography>
                          }
                        />
                      </ListItemButton>
                      <Divider />
                    </ListItem>
                  ) : null
                )}
              </List>
            ) : null}
          </Box>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default MenuItems;
